export default __webpack_public_path__ + "static/media/4_logo.35724c6d.png";